import { Dropdown } from 'react-bootstrap';
import { Colors } from '../../themes/colors';
import '../../themes/Button.scss';

export const TabItem = ({tab, value, onValueChanged} = {}) => {
    let isActive = value === tab.value || (!value && tab.default);
    const hasLinked = tab.linkedItems && tab.linkedItems.length > 0;

    if (hasLinked) {
      isActive = tab.linkedItems.some((item) => item.value === value);

      return (
        <Dropdown>
          <Dropdown.Toggle
            style={{
              alignItems: 'center',
              backgroundColor: isActive ? Colors.secondary_500 : Colors.primary_500,
              border: 'none',
              display: 'flex',
            }}
          >
            {tab.label}
          </Dropdown.Toggle>
          <Dropdown.Menu
            style={{
              border: 'none',
              borderRadius: 0,
              marginTop: 4,
              paddingBlock: 12,
            }}
          >
            {tab.linkedItems.map((linkedItem) => (
              <Dropdown.Item
                key={linkedItem.value}
                style={{
                  fontSize: 14,
                }}
                onClick={() => onValueChanged(linkedItem.value)}
              >
                {linkedItem.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      );
    }

    return (
      <button
        className="btn btn-info"
        type="button"
        style={{
          backgroundColor: isActive ? Colors.secondary_500 : Colors.primary_500,
          border: 'none',
        }}
        onClick={() => onValueChanged(tab.value)}
      >
        {tab.label}
      </button>
    );
  }